(function () {
  window.RotaTheme?.register('cart-drawer', {
    init(drawer) {
      const backdrop = drawer.querySelector('[data-cart-drawer-backdrop]');
      const closeButton = drawer.querySelector('[data-cart-drawer-close]');
      const triggers = Array.from(document.querySelectorAll('[data-cart-trigger]'));
      if (triggers.length === 0 || !window.RotaCartAPI) return null;

      let activeTrigger = triggers[0];
      let refreshController = null;
      const overlay = window.RotaOverlay?.create({
        panel: drawer,
        trigger: activeTrigger,
        backdrop,
        modal: true,
        initialFocus: () => closeButton,
        onOpen: () => {
          activeTrigger.setAttribute('aria-expanded', 'true');
          drawer.dispatchEvent(new CustomEvent('rm:cart:open'));
        },
        onClose: () => {
          activeTrigger.setAttribute('aria-expanded', 'false');
          drawer.dispatchEvent(new CustomEvent('rm:cart:close'));
        },
      });

      const setLoading = (loading) => {
        drawer.toggleAttribute('data-cart-loading', loading);
      };

      const refresh = async () => {
        refreshController?.abort();
        refreshController = new AbortController();
        const [cart, sections] = await Promise.all([
          window.RotaCartAPI.getCart(),
          window.RotaCartAPI.getSections(['cart-drawer'], refreshController.signal),
        ]);
        window.RotaCartAPI.updateCartCount(cart.item_count);
        window.RotaCartAPI.replaceSectionContent(sections['cart-drawer'], '[data-cart-drawer-content]', drawer);
        window.RotaCartAPI.announceUpdated(cart);
        return cart;
      };

      const open = async (trigger) => {
        activeTrigger = trigger;
        overlay?.open();
        setLoading(true);
        try {
          await refresh();
        } catch (error) {
          drawer.dispatchEvent(new CustomEvent('rm:cart:error', { detail: { error } }));
        } finally {
          setLoading(false);
        }
      };

      const handleTriggerClick = (event) => {
        const trigger = event.currentTarget;
        if (trigger.dataset.cartDrawerEnabled !== 'true') return;
        event.preventDefault();
        open(trigger);
      };

      const handleDocumentOpen = () => {
        open(activeTrigger);
      };

      const handleDocumentRefresh = async () => {
        setLoading(true);
        try {
          await refresh();
        } finally {
          setLoading(false);
        }
      };

      const handleDrawerClick = async (event) => {
        if (event.target.closest('[data-cart-drawer-close]')) {
          overlay?.close();
          return;
        }

        const removeButton = event.target.closest('[data-cart-remove]');
        if (removeButton) {
          event.preventDefault();
          setLoading(true);
          try {
            await window.RotaCartAPI.changeLine(removeButton.dataset.cartRemove, 0);
            await refresh();
          } finally {
            setLoading(false);
          }
          return;
        }

        const quantityButton = event.target.closest('[data-quantity-action]');
        if (!quantityButton) return;
        event.preventDefault();
        const wrapper = quantityButton.closest('[data-quantity-input]');
        const input = wrapper?.querySelector('[data-quantity-field]');
        const lineKey = wrapper?.dataset.lineKey;
        if (!input || !lineKey) return;
        const current = Number.parseInt(input.value, 10) || 1;
        const next = quantityButton.dataset.quantityAction === 'increase' ? current + 1 : Math.max(0, current - 1);
        setLoading(true);
        try {
          await window.RotaCartAPI.changeLine(lineKey, next);
          await refresh();
        } finally {
          setLoading(false);
        }
      };

      const handleDrawerChange = async (event) => {
        const input = event.target.closest('[data-quantity-field]');
        if (!input) return;
        const wrapper = input.closest('[data-quantity-input]');
        const lineKey = wrapper?.dataset.lineKey;
        if (!lineKey) return;
        setLoading(true);
        try {
          await window.RotaCartAPI.changeLine(lineKey, Math.max(0, Number.parseInt(input.value, 10) || 0));
          await refresh();
        } finally {
          setLoading(false);
        }
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', handleTriggerClick);
        trigger.setAttribute('aria-controls', drawer.id);
        trigger.setAttribute('aria-expanded', 'false');
      });
      drawer.addEventListener('click', handleDrawerClick);
      drawer.addEventListener('change', handleDrawerChange);
      document.addEventListener('rm:cart:refresh', handleDocumentRefresh);
      document.addEventListener('rm:cart:open', handleDocumentOpen);

      return () => {
        refreshController?.abort();
        overlay?.close({ restoreFocus: false });
        triggers.forEach((trigger) => trigger.removeEventListener('click', handleTriggerClick));
        drawer.removeEventListener('click', handleDrawerClick);
        drawer.removeEventListener('change', handleDrawerChange);
        document.removeEventListener('rm:cart:refresh', handleDocumentRefresh);
        document.removeEventListener('rm:cart:open', handleDocumentOpen);
      };
    },
  });
})();
